import { useEffect, useRef } from 'react';

export function useScrollToTop(dependencies: any[], delay: number = 100) {
    const isInitialMount = useRef(true);

    useEffect(() => {
        // Skip the first render
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        // Reset scroll position to top with a delay to ensure DOM is updated
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, delay);

        return () => clearTimeout(timer);
    }, dependencies);
}
